import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
import type { IPexelVideo } from "@/shared/types";
import { VIDEOS_PANEL_STOCK_MASONRY_COLS } from "../constants";
import type { IStockVideo } from "../types";
import { stockVideosToCols } from "../utils";

interface IState {
  columnsData: IStockVideo[][];
  category: string;
  queryRaw: string;
}

interface IActions {
  setColumnsData: (data: { videos: IPexelVideo[]; extend?: boolean }) => void;
  setCategory: (value: string) => void;
  setQueryRaw: (value: string) => void;
  reset: () => void;
}

const initState: IState = {
  columnsData: Array.from(
    { length: VIDEOS_PANEL_STOCK_MASONRY_COLS },
    () => [],
  ),
  category: "",
  queryRaw: "",
};

export const useStockStore = create<IState & IActions>((set) => ({
  ...initState,
  setColumnsData: ({ videos, extend }) => {
    return set((s) => ({
      columnsData: stockVideosToCols({ videos, extend })(s.columnsData),
    }));
  },
  setCategory: (category) => set({ category }),
  setQueryRaw: (queryRaw) => set({ queryRaw }),
  reset: () => set(initState),
}));

export const useStockStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => {
  return useStockStore(useShallow(selector));
};
